// extracted by mini-css-extract-plugin
export default {"devices":"Devices_devices__J2Iz9","device":"Devices_device__t2RuU"};